import api from "../services/api"

export async function getRefferalProduct({ email, searchTerm }) {
  const requestData = await api.get("/api/v1/product/referralform", {
    params: {
      email,
      searchTerm,
    },
  })

  return requestData.data
}

export async function getRefferalProductOptions() {
  const requestData = await api.get("/api/v1/product/referralform/options")

  return requestData.data
}

export async function saveRefferalProduct({ product }) {
  const requestData = await api.post("/api/v1/product/referralform", product)

  return requestData.data
}
